import Route from "vue-routisan";
import isAuthenticated from "./middlewares/isAuthenticated";
import isManager from "./middlewares/isManager";
import isNotFintech from "@/http/routes/middlewares/isNotFintech";
import isNotShipperCommercial from "@/http/routes/middlewares/isNotShipperCommercial";

Route.group({}, () => {
  Route.group({prefix: "home", beforeEnter: [isAuthenticated, isNotFintech, isNotShipperCommercial]}, () => {

    Route.redirect("/", to => {
      return {name: "home.menu"};
    });

    Route.view("/menu", () =>
      import(/* webpackChunkName: "manager" */ "src/resources/views/home/MainMenu.vue")
    ).name("home.menu").options({
      meta: {
        layout: () =>
          import(/* webpackChunkName: "guest" */ "src/resources/views/home/layout/Layout.vue")
      }
    });

    Route.view("/profile", () =>
      import(/* webpackChunkName: "manager" */ "src/resources/views/home/profile/Profile.vue")
    ).name("home.profile").options({
      meta: {
        layout: () =>
          import(/* webpackChunkName: "guest" */ "src/resources/views/home/layout/Layout.vue")
      }
    });

    Route.view("/tms", () =>
      import(/* webpackChunkName: "manager" */ "src/resources/views/home/TmsCatalde.vue")
    ).name("home.tms")
      .options({
        meta: {
          layout: () =>
            import(/* webpackChunkName: "guest" */ "src/resources/views/guest/Layout/EmptyLayout.vue")
        }
      });
  });
});

export default Route.all();
